<ng-container *ngFor="let item of categories">
  <div class="category-container" *ngIf="item.categories && item.categories.length > 0 && item.name !== 'time'">
    <p class="category-title" (click)="item.open = !item.open">{{item.name}}<mat-icon>{{item.open ? "arrow_drop_up" :
        "arrow_drop_down"}}</mat-icon></p>

    <ng-container *ngIf="item.open">
      <emodnet-menu-selector [categories]="item.categories" [parentCategory]="item" [map]="theMap"
        (filtersSelected)="selectFilters(item, true, parentCategory)"
        (activateTimeFilterRequest)="activateTimeFilterRequest.emit($event)"
        (activateCustom)="activateCustom.emit($event)">
      </emodnet-menu-selector>
    </ng-container>
  </div>
  <div class="filter-container" [style.background-color]="item.color ? item.color : ''"
    *ngIf="item.filters && item.filters.length > 0 && !item.selected && !item.menuExcluded && item.name.length > 0">
    <div class="filter-chip" [style.background-color]="item.color ? item.color : '' " (click)="selectFilters(item, true, parentCategory)">
      <!-- <img (click)="openDialog($event, item.description,item.name)" class="img-style" src="./assets/icons/info.svg" alt="" *ngIf="item.description && item.description !== 'delete'">
      <img (click)="delete(item.name)" class="img-style" src="./assets/icons/delete.svg" alt="" *ngIf="item.description && item.description === 'delete'"> -->
      <img class="img-style" src="./assets/icons/layer_data.svg" alt="" *ngIf="item.name == 'Data layer'">
      <img class="img-style" src="./assets/icons/virtual_access.svg" alt="" *ngIf="item.name == 'Polarin metadata catalogue - virtual access'">
      <img class="img-style" src="./assets/icons/polarin_metadata_catalog.svg" alt="" *ngIf="item.name == 'Polarin metadata catalogue'">
      <span class="filter-text">{{item.name}}</span>
    </div>
  </div>
</ng-container>
